import { useLang } from '@/i18n';
import { useRouter } from 'next/router';
import { useProductStore } from './../../../ProductProvider';
import styles from './index.module.scss';
import EfImg from 'elem/ui/ef-img';

export default function TheComp() {
    const { t } = useLang('hat');
    const { locale = 'us' } = useRouter();
    const { pageStatus } = useProductStore();

    return (
        <div className={styles.TheComp}>
            <EfImg
                className="banner-img"
                pc="https://websiteoss.ecoflow.com/upload/image/1726123202876/1_pc.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1726123202982/1_m.jpg"
            />
            <div className="banner-info">
                <p className="title">{t('A_title')}</p>
                {pageStatus === 'statusA' && <p className="desc">{t('A_desc')}</p>}
            </div>
        </div>
    );
}
